export class Site {
    lab:string ="";
    id:string = "";
    createdBy: string = "";
    createdDate: Date|null = null;
    updatedBy: string = "";
    updatedDate: Date|null = null;
    revision: number = 0;
    application: string = "";
}